import JsonLd from "@/components/JsonLd.tsx";
import JsonLdBreadcrumbList from "@/components/JsonLdBreadcrumbList.tsx";
import {config} from "@/config/config.ts";
import ClubsPage from "@/pages/clubs/ClubsPage.tsx";
import {createFileRoute} from '@tanstack/react-router'

// Public marketing page for sports clubs (venues): the header's For Clubs tab. A sibling of
// /for-players/ and /for-communities/; /clubs/ is the signed-in clubs area, so it is not used here.
export const Route = createFileRoute('/for-clubs')({
    component: RouteComponent,
})

const TITLE = "Sports Club Management Software | Events, Court Bookings & Player CRM | ScorePal";
const DESCRIPTION = "Grow your sports club with ScorePal. Run leagues and tournaments, engage players with leaderboards, manage court bookings and host corporate events.";

function RouteComponent() {
    const url = `${config.publicUrl}/for-clubs/`;

    return <>
        <title>{TITLE}</title>
        <meta name="description" content={DESCRIPTION} />
        <link rel="canonical" href={url} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="ScorePal" />
        <meta property="og:title" content="Grow Your Club with ScorePal" />
        <meta property="og:description" content="Run events, boost player engagement, fill your courts and deliver professional experiences — all from one platform." />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={`${config.publicUrl}/og-image.png`} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Grow Your Club with ScorePal" />
        <meta name="twitter:description" content="Events and leaderboards, court bookings and a player CRM for sports clubs." />
        <meta name="twitter:image" content={`${config.publicUrl}/og-image.png`} />

        <JsonLd id={`page${Route.id}/app`} item={{
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "ScorePal for Clubs",
            "applicationCategory": "SportsApplication",
            "operatingSystem": "Web, iOS, Android",
            "description": DESCRIPTION,
            "url": "https://scorepal.co/for-clubs/",
            "publisher": {"@type": "Organization", "name": "ScorePal"},
        }} />
        <JsonLdBreadcrumbList routeId={Route.id} crumbs={[{name: "For Clubs", item: "https://scorepal.co/for-clubs/"}]} />

        <ClubsPage />
    </>
}
